import { WebSocketMessage } from '@/providers/WebSocketProvider/WebSocketProvider.tsx';
import { useDiscoveryStore } from '@/store/useDiscoveryStore.ts';
import { useSummariesStore } from '@/store/useSummariesStore.ts';

export const handleBlocked = (ctxData: WebSocketMessage) => {
  if (ctxData.block_created_event?.contact_hid) {
    const { getLikesCount } = useSummariesStore.getState();
    const { filterCandidates } = useDiscoveryStore.getState();

    void getLikesCount();
    filterCandidates(ctxData.block_created_event?.contact_hid);
  }
};
